module.exports = __webpack_public_path__ + "static/media/14.e3a70502.jpg";